import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createAddUserModel } from 'features/add-user';
import { createBlockUserModel } from 'features/block-user';
import { createDeleteUserModel } from 'features/delete-user';
import { createEditUserModel } from 'features/edit-user';
import { createUnblockUserModel } from 'features/unblock-user';
import { accountTreeModel } from 'entities/account';
import { createUserRegistryModel } from 'entities/user';

const addUserModel = createAddUserModel();

const editUserModel = createEditUserModel();

const blockUserModel = createBlockUserModel();

const unblockUserModel = createUnblockUserModel();

const deleteUserModel = createDeleteUserModel();

const userRegistryModel = createUserRegistryModel({
	onUpdate: [
		addUserModel.addUserMutation.finished.success,
		blockUserModel.mutation.finished.success,
		unblockUserModel.mutation.finished.success,
		editUserModel.editUserMutation.finished.success,
	],
	onDelete: [deleteUserModel.mutation.finished.success],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: userRegistryModel.filters.accountIds.setValue,
});

chain(userRegistryModel.clearFilters, accountTreeModel.clearSelectedNodes);

export const usersPageModel = {
	editUserModel,
	userRegistryModel,
	blockUserModel,
	unblockUserModel,
	deleteUserModel,
	addUserModel,
};
